export enum ThemeFontWeights {
  Bold = 'bold',
  Medium = 'medium',
  Normal = 'normal',
}
